import PropTypes from 'prop-types';
import cls from 'classnames';

import { isDDEnv } from '@/utils/helper';

import RichText from '@/molecules/RichText/RichText';

import { getBlockClass, getBlockWrapperClass } from './BlockText.constants';
import { CtfBlockTextStyle } from '@/utils/constants';
import { TEXT_BASE_CLASS } from '@/atoms/Text/Text.constants';

export default function BlockText({
  fields,
  invert = false,
  noGap = false,
  richTextStyle = {
    paragraph: {},
  },
  blockWrapperStyle,
  blockTextStyle = '',
  compactSpace = false,
  alignBlockQuoteLeft = true,
  entries = [],
}) {
  const {
    blockAlignment,
    halfWidth,
    name,
    text: { content: textContent } = {},
    subtext: { content: subtextContent } = {},
    style,
    color,
    subtextColor,
    noMarginBottomMobile
  } = fields ?? {};

  const colorCls = color ? `text-${color}` : '';
  const subtextColorCls = subtextColor ? `text-${subtextColor}` : '';
  const blockTextWrapperClass = getBlockWrapperClass({
    blockAlignment,
    halfWidth,
    compactSpace,
    style: blockWrapperStyle,
    isBlockquote:
      style === CtfBlockTextStyle.BLOCKQUOTE ||
      style === CtfBlockTextStyle.BLOCKQUOTE_BODY_LARGE,
    alignBlockQuoteLeft,
    noMarginBottomMobile,
  });
  const blockTextClass = getBlockClass({
    noGap,
    compactSpace,
    halfWidth,
    style: `${colorCls} ${
      (style === CtfBlockTextStyle.BLOCKQUOTE ||
        style === CtfBlockTextStyle.BLOCKQUOTE_BODY_LARGE) &&
      !alignBlockQuoteLeft
        ? 'text-center'
        : ''
    } ${blockTextStyle}`,
    isBlockquote:
      style === CtfBlockTextStyle.BLOCKQUOTE ||
      style === CtfBlockTextStyle.BLOCKQUOTE_BODY_LARGE,
  });

  const isDD = isDDEnv();
  const blocktextStyle = isDD
    ? {
        ...(richTextStyle ?? {}),
        paragraph: {
          customFont: `${TEXT_BASE_CLASS['body']} ${colorCls}`,
        },
        list: {
          ol: `${TEXT_BASE_CLASS['body']} ${colorCls}`,
          ul: `${TEXT_BASE_CLASS['body']} ${colorCls}`,
          paragraph: {
            customFont: `${TEXT_BASE_CLASS['body']} ${colorCls}`,
          },
        },
      }
    : richTextStyle;

  const subtextStyle = {
    ...(richTextStyle ?? {}),
    paragraph: {
      customFont: `${
        isDD ? TEXT_BASE_CLASS['small'] : TEXT_BASE_CLASS['body']
      } ${subtextColorCls}`,
    },
    list: {
      ol: `${
        isDD ? TEXT_BASE_CLASS['small'] : TEXT_BASE_CLASS['body']
      } ${subtextColorCls}`,
      ul: `${
        isDD ? TEXT_BASE_CLASS['small'] : TEXT_BASE_CLASS['body']
      } ${subtextColorCls}`,
      paragraph: {
        customFont: `${
          isDD ? TEXT_BASE_CLASS['small'] : TEXT_BASE_CLASS['body']
        } ${subtextColorCls}`,
      },
    },
  };

  return (
    <div id={name} className={blockTextWrapperClass}>
      <div className={`w-full h-full ${blockTextClass}`}>
        {textContent?.length > 0 &&
          textContent.map(({ nodeType, content }, index) => (
            <RichText
              entries={entries}
              isBlockquote={style === CtfBlockTextStyle.BLOCKQUOTE}
              isBlockquoteBodyLarge={
                style === CtfBlockTextStyle.BLOCKQUOTE_BODY_LARGE
              }
              nodeType={nodeType}
              content={content}
              key={index}
              invert={invert}
              richTextStyle={blocktextStyle}
            />
          ))}
        {(style === CtfBlockTextStyle.BLOCKQUOTE ||
          style === CtfBlockTextStyle.BLOCKQUOTE_BODY_LARGE) &&
          subtextContent?.length > 0 &&
          subtextContent.map(({ nodeType, content }, index) => (
            <RichText
              entries={entries}
              nodeType={nodeType}
              content={content}
              key={index}
              invert={invert}
              richTextStyle={subtextStyle}
            />
          ))}
      </div>
    </div>
  );
}

BlockText.propTypes = {
  blockWrapperStyle: PropTypes.string,
  blockTextStyle: PropTypes.string,
  invert: PropTypes.bool,
  richTextStyle: PropTypes.shape({
    paragraph: PropTypes.shape({
      blockquoteFont: PropTypes.string,
      customFont: PropTypes.string,
    }),
  }),
  fields: PropTypes.shape({
    blockAlignment: PropTypes.string,
    halfWidth: PropTypes.bool,
    name: PropTypes.string,
    text: PropTypes.shape({
      content: PropTypes.array,
    }),
    style: PropTypes.string,
  }),
};
